import * as React from 'react';

import { WrappedFieldProps } from 'redux-form';

require('../../styles/components/_material-text-input.scss');

export interface Props extends WrappedFieldProps {
    label: string;
    placeholder?: string;
    choices: [string, string][];
}

export interface State {
    isOpen: boolean;
    valuePresentation: string;
    selectedValue: string;
    choices: [string, string][];
}

export class MaterialSelectInput extends React.Component<Props, State> {
    input: HTMLInputElement;

    constructor(props: Props) {
        super(props);

        this.state = {
            isOpen: false,
            valuePresentation: '',
            selectedValue: '',
            choices: props.choices,
        };
    }

    handleFocus(e: React.FocusEvent<HTMLInputElement>) {
        const {
            input: { onFocus },
            placeholder,
        } = this.props;
        e.currentTarget.placeholder = (placeholder && placeholder) || '';
        onFocus(e);

        this.setState({ isOpen: true });
    }

    handleBlur(e: React.SyntheticEvent<HTMLInputElement>) {
        const {
            input: { onBlur },
        } = this.props;
        e.currentTarget.placeholder = '';

        if (!this.state.selectedValue) {
            e.currentTarget.value = '';
        }

        onBlur(this.state.selectedValue);

        this.setState({
            isOpen: false,
            valuePresentation: this.state.selectedValue ? this.state.valuePresentation : '',
            choices: this.state.selectedValue ? this.state.choices : this.props.choices,
        });
    }

    render() {
        const {
            label,
            input: { onFocus, onBlur, onChange, ...input },
            meta: { error, touched },
        } = this.props;
        const { isOpen, valuePresentation, selectedValue, choices } = this.state;

        const hasValue = input.value.length !== 0;

        return (
            <div className='MaterialTextInput'>
                <input
                    {...input}
                    onFocus={(e: React.FocusEvent<HTMLInputElement>) => this.handleFocus(e)}
                    onBlur={(e: React.SyntheticEvent<HTMLInputElement>) => this.handleBlur(e)}
                    type='text'
                    ref={(el: HTMLInputElement) => {
                        this.input = el;
                    }}
                    onChange={(e) => {
                        const needle = e.currentTarget.value;
                        let exactMatch: [string, string] | false = false;

                        const newChoices = this.props.choices.filter(([value, label]) => {
                            const lowerLabel = label.toLowerCase();
                            if (lowerLabel === needle.toLowerCase()) {
                                exactMatch = [value, label];
                            }
                            return lowerLabel.startsWith(needle.toLowerCase());
                        });

                        if (exactMatch) {
                            onChange(exactMatch[0]);
                        }

                        this.setState({
                            valuePresentation: exactMatch ? exactMatch[1] : needle,
                            choices: newChoices,
                            selectedValue: exactMatch ? exactMatch[0] : '',
                        });
                    }}
                    value={valuePresentation}
                    className={'MaterialTextInput--input' + (touched && error ? ' MaterialTextInput--input__has-error' : '')}
                />
                <span
                    className='MaterialTextInput--select-chevron'
                    onClick={(e) => {
                        this.input.focus();
                    }}
                />
                <input value={input.value} type='hidden' />
                <span className='MaterialTextInput--bar' />
                <div className={'MaterialTextInput--select-wrapper' + (isOpen ? ' MaterialTextInput--select-wrapper__open' : '')}>
                    {choices.map(([value, label]) => (
                        <div
                            key={value}
                            className={
                                'MaterialTextInput--select-option' +
                                (selectedValue === value ? ' MaterialTextInput--select-option__active' : '')
                            }
                            onMouseDown={(e: React.SyntheticEvent<HTMLDivElement>) => {
                                this.setState(
                                    {
                                        valuePresentation: label,
                                        selectedValue: value,
                                    },
                                    () => onChange(value)
                                );
                            }}
                        >
                            {label}
                        </div>
                    ))}
                    {choices.length === 0 && <div className='MaterialTextInput--select-alert'>Nothing found</div>}
                </div>
                <label className={'MaterialTextInput--label' + (hasValue ? ' MaterialTextInput--label__active' : '')}>{label}</label>
                {touched && error && <span className='MaterialTextInput--error'>{error}</span>}
            </div>
        );
    }
}

export default MaterialSelectInput;
